import React from "react";
import FixHeader from "../component/FixHeader";
import Footer from "../component/Footer";
import Loader from "../component/Loader";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
    const navigate = useNavigate()
    return (
        <div className="site_contain">
            <Loader />
            {/* <!-- ====================================== Main Menu Header ===================================== --> */}
            <FixHeader />
            {/* <!-- ====================================== FAQ Section Two ===================================== --> */}
            <section className="about-section-two" id="coming_soon_section">
                <div className="container">
                    <div className="waviy">
                        <span className="i-1">4</span>
                        <span className="i-2">0</span>
                        <span className="i-3">4</span>
                    </div>
                    <h1 className="page-not-found">Page Not Found</h1>
                    <h2 className="suptext404">
                        Oops! The page you are looking for does not exist. It might have
                        been moved or deleted.
                    </h2>
                    <div className="back-btn">
                        <div onClick={() => navigate("/")} className="button button404" data-text="Back To Home">
                            <span>Back To Home</span>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    );
};

export default NotFound;
